import { render, staticRenderFns } from "./debug.vue?vue&type=template&id=156431b5&"
import script from "./debug.vue?vue&type=script&lang=ts&"
export * from "./debug.vue?vue&type=script&lang=ts&"
import style0 from "./debug.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports